import type { PositionBudgetSummary, ScholarshipModel } from '../../../../types/scholarships';
import { formatMoney } from './scholarshipMoney';

interface Props {
  budget: PositionBudgetSummary;
  scholarshipModel: ScholarshipModel;
}

/**
 * Compact "used / budget" line shown on a depth-chart card when a per-position budget is
 * configured. Dollars for the Percentage model, one-decimal scholarship counts otherwise.
 * An over-budget state is flagged with a non-color cue ("OVER") in addition to color so it
 * survives print, where backgrounds/colors are often dropped.
 */
export const PositionBudgetLine = ({ budget, scholarshipModel }: Props) => {
  const fmt = (v: number | null): string => {
    if (v == null) return '—';
    return scholarshipModel === 'Percentage' ? formatMoney(v) : v.toFixed(1);
  };

  return (
    <p
      className={`depth-chart-card__budget${budget.isOver ? ' depth-chart-card__budget--over' : ''}`}
    >
      <span className="depth-chart-card__budget-label">Budget</span>{' '}
      {fmt(budget.used)} / {budget.budget == null ? '∞' : fmt(budget.budget)}
      {budget.isOver && <span className="depth-chart-card__budget-flag"> OVER</span>}
    </p>
  );
};
